import { z } from "zod";

export const InventaireCreationSourceSchema = z.enum(['MOBILE', 'WEB']);
export type InventaireCreationSource = z.infer<typeof InventaireCreationSourceSchema>;

export const sortBySchema = z.enum(["recent", "oldest", "alphanum"]).default("recent");
export const metaSchema = z.object({
  page: z.number(),
  limit: z.number(),
  totalPages: z.number(),
  total :z.number(),
  hasNextPage: z.boolean(),
  hasPreviousPage: z.boolean(),
})